export const initCookiesBanner = () => {
  const selector = ".cookiesjsr-banner.active";
  let hasFocused = false;
  let hasMoved = false;

  const isVisible = (el) => {
    if (!el) return false;
    if (el.getClientRects().length === 0) return false;
    return true;
  };

  const shouldAutoFocus = () => {
    const active = document.activeElement;
    return !active || active === document.body || active === document.documentElement;
  };

  const focusBanner = (banner) => {
    if (hasFocused || !banner || !isVisible(banner) || !shouldAutoFocus()) {
      return;
    }
    const focusTarget = banner.querySelector(
      "button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])"
    );
    if (focusTarget) {
      focusTarget.focus();
      hasFocused = true;
    }
  };

  const findAndFocus = () => {
    const banner = document.querySelector(selector);
    if (banner) {
      if (!hasMoved) {
        const block =
          banner.closest("#block-b5nova-cookiesui") ||
          banner.closest(".block-cookies") ||
          banner.closest("#cookiesjsr") ||
          banner;
        const skipLinks = document.querySelector(".skip-links");
        if (block && skipLinks && skipLinks.parentNode) {
          skipLinks.parentNode.insertBefore(block, skipLinks);
          hasMoved = true;
        }
      }
      focusBanner(banner);
      return true;
    }
    return false;
  };

  if (findAndFocus()) return;

  const observer = new MutationObserver(() => {
    if (findAndFocus()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};
